import { useState, useGlobal, useEffect } from "reactn";
import { Link } from "react-router-dom";
import { Table, Row, Col, Spinner, Pagination } from "react-bootstrap";
import Button from "../../../components/button/button.component";
import InputField from "../../../components/form/input-field/input-field.component";
import InterestModal from "../../../components/modal/interest-modal/interest-modal.component";
import { fetchData, putData } from "../../../api/api";
import PaginationBar from "../../../components/pagination-bar/pagination-bar.component";
import PageLayout from "../../../components/page-layout/page-layout.component";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plus.svg";
import ConfirmModal from "../../../components/modal/confirm-modal/confirm-modal.component";
import HaveAccess from "../../../access-control.jsx";

const InterestsPage = (props) => {
  const [currentUser, setCurrentUser] = useGlobal("currentUser");
  const [interests, setInterests] = useGlobal("interests");
  const canWrite = HaveAccess("interest", "Write", currentUser);

  const [state, setState] = useState({
    activeTab: 0,
    showInterestModal: false,
    InterestModalType: null,
    currentInterest: null,
    showConfirmModal: false,
    confirmDescription: "",
    confirmProcessing: false,
    confirmTitle: "",
    confirmError: null,
    fetching: false,
    canFetch: true,
    error: null,
    query: "",
    queryDisabled: "",
    activeInterests: [], //interests.filter(interest => interest.disabled === false),
    disabledInterests: [], // interests.filter(interest => interest.disabled === true),
  });

  const [paginate, setPaginate] = useState({
    totalItems: 0,
    page: 0,
    pageSize: 10,
  });

  const [disabledPaginate, setDisabledPaginate] = useState({
    totalItems: 0,
    page: 0,
    pageSize: 10,
  });

  useEffect(() => {
    if (interests && state.canFetch) {
      setState({
        ...state,
        canFetch: false,
        activeInterests: interests.filter(
          (interest) => interest.disabled === false
        ),
        disabledInterests: interests.filter(
          (interest) => interest.disabled === true
        ),
      });
    }

    if (state.canFetch && !state.fetching && !interests) {
      setState({
        ...state,
        fetching: true,
        canFetch: false,
      });

      let authToken = currentUser.token.actual;
      fetchData("interest/", authToken, false).then((response) => {
        if (response.success) {
          setState({
            ...state,
            fetching: false,
            canFetch: false,
            error: null,
            activeInterests: response.data.filter(
              (interest) => interest.disabled === false
            ),
            disabledInterests: response.data.filter(
              (interest) => interest.disabled === true
            ),
          });
          setInterests(response.data);
          return;
        }
        setState({
          ...state,
          fetching: false,
          canFetch: false,
          error: response.message,
        });
      });
    }
  }, [
    interests,
    state.activeInterests,
    state.disabledInterests,
    state.canFetch,
    state.limit,
    paginate,
  ]);

  //edit or add --callback
  function onInterestUpdated(data) {
    setState({
      ...state,
      activeInterests: data.filter((interest) => interest.disabled === false),
      disabledInterests: data.filter((interest) => interest.disabled === true),
      showInterestModal: false,
    });

    setInterests(data);
  }

  //confirm disable or enable interest
  function onInterestDisableOrEnable() {
    setState({ ...state, confirmProcessing: true });
    const formData = new FormData();
    formData.append("description", state.currentInterest.description);
    formData.append(
      "disabled",
      state.currentInterest.disabled ? "False" : "True"
    );
    //formData.append("caption", state.currentInterest.caption);
    //formData.append("color_code", state.currentInterest.color_code);
    //formdata.append("cover_photo":"")

    putData(
      `interest/${state.currentInterest.id}/`,
      formData,
      currentUser.token.actual,
      true
    ).then((response) => {
      if (response.success) {
        let current = interests.filter(
          (interest) => interest.id !== state.currentInterest["id"]
        );
        let newData = [...current, response.data];
        setState({
          ...state,
          confirmProcessing: false,
          confirmError: null,
          showConfirmModal: false,
          activeInterests: newData.filter(
            (interest) => interest.disabled === false
          ),
          disabledInterests: newData.filter(
            (interest) => interest.disabled === true
          ),
        });
        setInterests(newData);
        return;
      }
      setState({
        ...state,
        confirmProcessing: false,
        confirmError: response.message,
      });
    });
  }

  //active filtering
  const activeInterests = () => {
    let active = state.activeInterests;
    let totalItems = active.length;

    if (state.query.length > 0) {
      active = active.filter((interest) =>
        interest.description.toLowerCase().includes(state.query)
      );
      //list length
      totalItems = active.length;
    }

    // paginate
    const { page, pageSize } = paginate;
    const start = page * pageSize;
    const end = start + pageSize;

    return { items: active.slice(start, end), totalItems: totalItems };
  };

  //disabled mentors filtering
  const disabledInterests = () => {
    let disabled = state.disabledInterests;
    let totalItems = disabled.length;

    if (state.queryDisabled.length > 0) {
      disabled = disabled.filter(
        (interest) =>
          interest["id"].includes(state.queryDisabled) ||
          interest.description.toLowerCase().includes(state.queryDisabled)
      );
      //list length
      totalItems = disabled.length;
    }

    // paginate
    const { page, pageSize } = disabledPaginate;
    const start = page * pageSize;
    const end = start + pageSize;

    return { items: disabled.slice(start, end), totalItems: totalItems };
  };

  return (
    <>
      <InterestModal
        interest={state.currentInterest}
        token={currentUser.token.actual}
        type={state.InterestModalType}
        show={state.showInterestModal}
        onHide={() => {
          setState({ ...state, showInterestModal: false });
        }}
        onUpdated={onInterestUpdated}
      />

      <ConfirmModal
        show={state.showConfirmModal}
        token={currentUser.token.actual}
        title={state.confirmTitle}
        description={state.confirmDescription}
        processing={state.confirmProcessing}
        error={state.confirmError}
        onHide={() => {
          setState({ ...state, confirmError: null, showConfirmModal: false });
        }}
        onConfirm={onInterestDisableOrEnable}
      />

      <PageLayout activeLink="interest" parentMenu="demographics">
        <div>
          <div className="text-grey text-20 font-bold mb-20">Interest</div>

          <Row>
            <Col md={7}>
              <div className="d-flex flex-wrap align-center mb-20">
                <Button
                  classes={`pill success ${state.activeTab == 0} mr-2  mb-20`}
                  disabled={state.activeTab == null}
                  onClick={() => {
                    setState({ ...state, activeTab: 0 });
                  }}
                >
                  Active({state.activeInterests.length})
                </Button>

                <Button
                  classes={`pill success ${state.activeTab == 1}  mb-20 mr-3`}
                  disabled={state.activeTab == null}
                  onClick={() => {
                    setState({ ...state, activeTab: 1 });
                  }}
                >
                  Disabled({state.disabledInterests.length})
                </Button>
                {canWrite && (
                  <Button
                    classes={`small success w-200  mb-20`}
                    onClick={() => {
                      setState({
                        ...state,
                        InterestModalType: "Add",
                        showInterestModal: true,
                      });
                    }}
                  >
                    <PlusIcon /> <span className="pl-2">Add Interest</span>
                  </Button>
                )}
              </div>
            </Col>

            <Col md={5}>
              {state.activeTab == 0 && (
                <InputField
                  placeholder="Search  interests"
                  classes="small mb-20"
                  isSearch
                  value={state.query}
                  onChange={(ev) => {
                    setState({ ...state, query: ev.target.value });
                    if (paginate.page > 0)
                      setPaginate({ ...paginate, page: 0 });
                  }}
                />
              )}

              {state.activeTab == 1 && (
                <InputField
                  placeholder="Search disabled  interests"
                  classes="small mb-20"
                  isSearch
                  value={state.queryDisabled}
                  onChange={(ev) => {
                    setState({ ...state, queryDisabled: ev.target.value });
                    if (disabledPaginate.page > 0)
                      setDisabledPaginate({ ...disabledPaginate, page: 0 });
                  }}
                />
              )}
            </Col>
          </Row>

          {state.activeTab == 0 && state.activeInterests.length > 0 && (
            <div>
              <Table bordered responsive className="table-white">
                <thead>
                  <tr>
                    <th>Interest</th>
                    <th>Mentors</th>
                    <th>Members</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {activeInterests().items.map((interest) => (
                    <tr key={interest.id}>
                      <td>
                        <span className="text-16 text-grey font-400">
                          {interest.description}{" "}
                        </span>
                      </td>
                      <td>
                        <span className="text-16 text-grey font-400">
                          {interest?.total_mentors}
                        </span>
                      </td>
                      <td>
                        <span className="text-16 text-grey font-400">
                          {interest?.total_members}
                        </span>
                      </td>

                      <td>
                        <span
                          hidden={!canWrite}
                          className="text-16 text-success font-400 pointer mr-2"
                          onClick={() => {
                            setState({
                              ...state,
                              InterestModalType: "Edit",
                              currentInterest: interest,
                              showInterestModal: true,
                            });
                          }}
                        >
                          Edit
                        </span>

                        <span
                          hidden={!canWrite}
                          className="text-16 text-warning font-400 pointer"
                          onClick={() => {
                            setState({
                              ...state,
                              currentInterest: interest,
                              confirmTitle: "Disable  interest",
                              confirmDescription: `Do you want to disable this  interest [ ${interest.description} ] `,
                              showConfirmModal: true,
                            });
                          }}
                        >
                          Disable
                        </span>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={4}>
                      <PaginationBar
                        page={paginate.page}
                        pageSize={paginate.pageSize}
                        totalItems={activeInterests().totalItems}
                        onChangePage={(newPage) => {
                          setPaginate({ ...paginate, page: newPage });
                        }}
                        onChangeRowsPerPage={(size) => {
                          setPaginate({ ...paginate, pageSize: size, page: 0 });
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
          {/*no active interests */}
          {state.activeTab == 0 &&
            state.activeInterests.length == 0 &&
            !state.fetching && (
              <div className="text-grey text-16 mb-20">
                {" "}
                No active Interests{" "}
              </div>
            )}

          {state.activeTab == 1 && state.disabledInterests.length > 0 && (
            <div>
              <Table bordered responsive className="table-white">
                <thead>
                  <tr>
                    <th>Interest</th>
                    <th>Mentors</th>
                    <th>Members</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {disabledInterests().items.map((interest) => (
                    <tr key={interest.id}>
                      <td>
                        <span className="text-16 text-grey font-400">
                          {interest.description}{" "}
                        </span>
                      </td>
                      <td>
                        <span className="text-16 text-grey font-400">
                          {interest?.total_mentors}
                        </span>
                      </td>
                      <td>
                        <span className="text-16 text-grey font-400">
                          {interest?.total_members}{" "}
                        </span>
                      </td>
                      <td>
                        <span
                          hidden={!canWrite}
                          className="text-16 text-success font-400 pointer mr-2"
                          onClick={() => {
                            setState({
                              ...state,
                              InterestModalType: "Edit",
                              currentInterest: interest,
                              showInterestModal: true,
                            });
                          }}
                        >
                          Edit
                        </span>

                        <span
                          hidden={!canWrite}
                          className="text-16 text-success font-400 pointer"
                          onClick={() => {
                            setState({
                              ...state,
                              currentInterest: interest,
                              confirmTitle: "Enable  interest",
                              confirmDescription: `Do you want to enable this  interest [ ${interest.description} ] `,
                              showConfirmModal: true,
                            });
                          }}
                        >
                          Enable
                        </span>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td colSpan={4}>
                      <PaginationBar
                        page={disabledPaginate.page}
                        pageSize={disabledPaginate.pageSize}
                        totalItems={disabledInterests().totalItems}
                        onChangePage={(newPage) => {
                          setDisabledPaginate({
                            ...disabledPaginate,
                            page: newPage,
                          });
                        }}
                        onChangeRowsPerPage={(size) => {
                          setDisabledPaginate({
                            ...disabledPaginate,
                            pageSize: size,
                            page: 0,
                          });
                        }}
                      />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          )}
          {/*no disabled interest */}
          {state.activeTab == 1 &&
            state.disabledInterests.length == 0 &&
            !state.fetching && (
              <div className="text-grey text-16 mb-20">
                {" "}
                No disabled interests{" "}
              </div>
            )}

          <div className="mt-10 d-flex justify-center">
            <Spinner
              hidden={!state.fetching || state.query.length > 0}
              animation="border"
              variant="primary"
            />
          </div>

          <div className="mt-30" hidden={!state.error || state.fetching}>
            <span className="mt-10 text-danger">{state.error}.</span>
            &nbsp;
            <span
              className="text-primary pointer font-bold"
              onClick={() => setState({ ...state, canFetch: true })}
            >
              TRY AGAIN
            </span>
          </div>
        </div>
      </PageLayout>
    </>
  );
};

export default InterestsPage;
